// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advantages-card {
    transform-style: preserve-3d;
    perspective: 1000px;
    height: 300px;
}

.advantages-card__front {
    transform: rotateY(0deg);
    transform-style: preserve-3d;
    min-height: 300px;
    transition: transform 0.6s ease;
    backface-visibility: hidden;
    border-radius: 2px;
}
.abs {
    position: absolute;
    padding: 30px 25px;
    left: 0;
    bottom: 0;
    top: 50%;
    height: 100%;
    width: 100%;
    border-radius: 2px;
    outline: 1px solid transparent;
    perspective: inherit;
    backface-visibility: hidden;
    transform: translateY(-50%) translateZ(60px) scale(0.94);
    z-index: 2;   
} 
.advantages-card:hover .advantages-card__front {
    transform: rotateY(180deg);
    backface-visibility: hidden;
}


.advantages-card__back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 300px;
    border-radius: 2px;
    transition: transform 0.6s ease;
    transform: rotateY(-180deg);
    transform-style: preserve-3d;
    color: #fff;
}
.abc {
    position: absolute;
    padding: 30px 25px;
    left: 0;
    bottom: 0;
    top: 50%;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    outline: 1px solid transparent;
    perspective: inherit;
    backface-visibility: hidden;
    transform: translateY(-50%) translateZ(60px) scale(0.94);
    background-color: #00ce87;
    z-index: 2;
}
.advantages-card:hover .advantages-card__back {
    transform: rotateY(0deg);
}
.advantages-card__back:hover .abc{
    backface-visibility: visible;
}



@media (max-width: 768px) {
    .advantages-card {
        width: 80%;
    }
}
@media (max-width: 600px) {
    .advantages-card {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/components/advantages/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;IAC3B,wDAAwD;IACxD,UAAU;AACd;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;IAC3B,wDAAwD;IACxD,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,4BAA4B;AAChC;;;;AAIA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".advantages-card {\n    transform-style: preserve-3d;\n    perspective: 1000px;\n    height: 300px;\n}\n\n.advantages-card__front {\n    transform: rotateY(0deg);\n    transform-style: preserve-3d;\n    min-height: 300px;\n    transition: transform 0.6s ease;\n    backface-visibility: hidden;\n    border-radius: 2px;\n}\n.abs {\n    position: absolute;\n    padding: 30px 25px;\n    left: 0;\n    bottom: 0;\n    top: 50%;\n    height: 100%;\n    width: 100%;\n    border-radius: 2px;\n    outline: 1px solid transparent;\n    perspective: inherit;\n    backface-visibility: hidden;\n    transform: translateY(-50%) translateZ(60px) scale(0.94);\n    z-index: 2;   \n} \n.advantages-card:hover .advantages-card__front {\n    transform: rotateY(180deg);\n    backface-visibility: hidden;\n}\n\n\n.advantages-card__back {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    min-height: 300px;\n    border-radius: 2px;\n    transition: transform 0.6s ease;\n    transform: rotateY(-180deg);\n    transform-style: preserve-3d;\n    color: #fff;\n}\n.abc {\n    position: absolute;\n    padding: 30px 25px;\n    left: 0;\n    bottom: 0;\n    top: 50%;\n    width: 100%;\n    height: 100%;\n    border-radius: 2px;\n    outline: 1px solid transparent;\n    perspective: inherit;\n    backface-visibility: hidden;\n    transform: translateY(-50%) translateZ(60px) scale(0.94);\n    background-color: #00ce87;\n    z-index: 2;\n}\n.advantages-card:hover .advantages-card__back {\n    transform: rotateY(0deg);\n}\n.advantages-card__back:hover .abc{\n    backface-visibility: visible;\n}\n\n\n\n@media (max-width: 768px) {\n    .advantages-card {\n        width: 80%;\n    }\n}\n@media (max-width: 600px) {\n    .advantages-card {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
